export const SET_SESSION = 'session/SET_SESSION'
export const CLEAR_SESSION = 'session/CLEAR_SESSION'
